import React, { useState, useEffect } from 'react';
import { Snackbar, Box, Typography } from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

/**
 * Silent update UX (A9): informational only — reload is driven by pwaService + service worker.
 * Optional: `swUpdateDeferred` when an update is held until unsaved work is cleared.
 */
export default function AppUpdateBanner() {
  const [applying, setApplying] = useState(false);
  const [deferred, setDeferred] = useState(false);

  useEffect(() => {
    const onApplying = () => {
      setApplying(true);
      setDeferred(false);
    };
    const onDeferred = () => {
      setDeferred(true);
    };
    window.addEventListener('swUpdateApplying', onApplying);
    window.addEventListener('swUpdateDeferred', onDeferred);
    return () => {
      window.removeEventListener('swUpdateApplying', onApplying);
      window.removeEventListener('swUpdateDeferred', onDeferred);
    };
  }, []);

  return (
    <>
      <Snackbar
        open={applying}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={2500}
        onClose={() => setApplying(false)}
        sx={{ top: { xs: 70, md: 74 } }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            bgcolor: 'primary.main',
            borderRadius: 2,
            px: 2,
            py: 1.25,
            boxShadow: 6,
            maxWidth: 420,
          }}
        >
          <SystemUpdateAltIcon sx={{ color: 'primary.contrastText' }} />
          <Typography variant="body2" sx={{ flex: 1, color: 'primary.contrastText' }}>
            Updating to the latest version…
          </Typography>
        </Box>
      </Snackbar>

      <Snackbar
        open={deferred}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        autoHideDuration={6000}
        onClose={() => setDeferred(false)}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            bgcolor: 'info.dark',
            borderRadius: 2,
            px: 2,
            py: 1.25,
            boxShadow: 4,
            maxWidth: 440,
          }}
        >
          <Typography variant="body2" sx={{ color: 'info.contrastText' }}>
            An update will apply after you finish editing or change screens.
          </Typography>
        </Box>
      </Snackbar>
    </>
  );
}
